import apiRequest from "./apiRequest"
import { redirect } from "react-router-dom";
import encryptedapiRequest from "./encryptedapiRequest";


export const displayPostPageLoader = async ({ params }) => {
  const id = params.id;

  // If ID is not a number, throw a redirect or an error
  if (!/^\d+$/.test(id)) {
    // Option 1: Throw 404 response (React Router will catch)
    throw new Response("Not Found", { status: 404 });

    // OR Option 2: Redirect to a safe page
    // throw redirect("/not-found");
  }

  // const res = await apiRequest("/posts/" + id);
  const res = await encryptedapiRequest("/posts/" + id);


  // console.log("displaypostpage loader loaded")

  return {postResponse:res.data||[]};
};


// import apiRequest from "./apiRequest";

export const listPageLoader = async ({ request }) => {
  const query = request.url.split("?")[1];
  const qtrystr = query ? "?" + query : "";

  // Always return consistent structure
  const res = await apiRequest("/posts" + qtrystr);

  return { postResponse: res.data || [] };
};



// export const  listPageLoader=async ({request,params})=>{
//     const query=request.url.split("?")[1]
//     // console.log("query is ",query)
//     const qtrystr=query?"?"+query:''
//     // console.log("qtrystr is ",qtrystr)

//     // const postPromise= apiRequest("/posts/?"+query?query:'')
//     const postPromise= apiRequest("/posts"+qtrystr)

//     // postPromise.then((data) => {
//     //   // console.log("Resolved Data:", data);
//     // });
//     return ({
//       postResponse:postPromise  
//     })
    
// };

// export const  profilePageLoader=async()=>{
//   const postPromise= await apiRequest("/users/profilePosts/")
//   const chatPromise= await apiRequest("/chats")
//   return ({
//     postResponse: postPromise,  
//     chatResponse: chatPromise
//   })  

// };


export const SaveProfilePageLoader = async () => {

  try {
      const postRes = await encryptedapiRequest("/users/profilePosts/");
      // const postRes = await apiRequest("/users/profilePosts/");

      
      let chatRes = { data: [] }; // default fallback
      if (import.meta.env.VITE_REACT_APP_USE_SOCKETS === "true") {
        chatRes = await apiRequest("/chats");
      }
    
      // console.log("Profileposts/",postRes)
      // console.log("chats/",chatRes)
      // console.log("profile page loader loaded")
      return {
        postResponse: postRes.data ||[],
        chatResponse: chatRes.data||[],
      };
    
  } catch (error) {
    
    if (error.response && error.response.status === 403) {
      // Session likely expired or user not authenticated
      return redirect("/login");
    }
  }






};


// export const InventoryPageLoader = async ({request,params}) => {
//   const postPromise = await apiRequest("/posts/posts/?userid="+params.id);
//   return {
//     postResponse:postPromise
//   }
//   // let chatPromise = { data: [] }; // default fallback
//   // if (import.meta.env.VITE_REACT_APP_USE_SOCKETS === "true") {
//   //   chatPromise = await apiRequest("/chats");
//   // }


//   // return {
//   //   postResponse: postPromise,
//   //   chatResponse: chatPromise,
//   // };
// };



export const  displayProfilePageLoader=async({request,params})=>{

  // console.log("display page loader called with params",params)

  // const profilePromise= await apiRequest("/users/userdetails/"+params.id)
  const profilePromise= await encryptedapiRequest("/users/userdetails/"+params.id)


  // const inventoryPromise= await apiRequest("/chats")
  // console.log("profile promise is ",profilePromise.data[0])

  // const postsPromise=await apiRequest("/posts?userid="+params.id)
  // console.log("displayprofilepage loader loaded")

  return ({
    profileResponse: profilePromise.data||[],  
    // postsResponse:postsPromise.data||[],
    // chatResponse: chatPromise
  })  

};




export const  ClientsListPageLoader=async()=>{
  // const ClientsPromise= await apiRequest("/clients")

  const ClientsPromise= await encryptedapiRequest("/clients")

  // console.log("displayclientspage loader loaded")


  return ({
    ClientsResponse: ClientsPromise.data||[],  
  })  

};



export const  ClientPageLoader=async({request,params})=>{
  const clientid = params.id;  // ✅ use params.id
  // console.log("Loader got clientid:", clientid);
  if (clientid === "0") {
    return { ClientResponse: null };
  }

  // const ClientPromise= await apiRequest(`/clients/${clientid}`)

  const ClientPromise= await encryptedapiRequest(`/clients/${clientid}`)


  // console.log("displayclientspage loader loaded")
  return ({
    ClientResponse: ClientPromise.data||[],  
  })  

};


export const  MasterColoniesLocationLoader=async()=>{

  const MasterColonyPromise= await encryptedapiRequest(`/masters/colonieslocation`)
  // console.log("displayclientspage loader loaded")
  return ({
    MasterColonyLocationResponse: MasterColonyPromise.data||[],  
  })  

};


export const  BuilderDataPageLoader=async(userid)=>{

  // console.log("BuilderDatapage Loader Parameter: UserId ",userid)

  // this will verify the subscription 
  // if true it wil get data for builders from getposts
  // else it will send da 

  // const verifiedSubscription=true;

  // let DataPageResponse=[];
  // let DataPagePromise=[];
  // if (verifiedSubscription===true){
    
    // DataPagePromise= await apiRequest(`/posts?builderpost=true`)

    let verifiedPromise= await apiRequest(`/users/datasubscribed/${userid}`)

    // console.log ("Loader Response: ",verifiedPromise)


  // }
  // console.log("displayclientspage loader loaded")
      return ({ 
        verifiedSubscription: verifiedPromise.data.subscription.isSubscribed
        // DataPageResponse: verifiedSubscription? DataPagePromise.data||[]:[]    
  })  
};



export const  ColonyPageLoader=async({request,params})=>{
  const colonyid = params.id;  // ✅ use params.id
  // console.log("Loader got colonyid:", colonyid);
  // if (colonyid === "0") {
  //    ColonyResponse: null ;
  // }

  const ColonyPromise= await encryptedapiRequest(`/masters/colonieslocation/${colonyid}`)
  // console.log("displayclientspage loader loaded")
  const CityPromise= await encryptedapiRequest(`/masters/cities`)

  return ({
    ColonyResponse: ColonyPromise.data[0]||[],
    CityResponse:CityPromise.data||[]  
  })  
};


export const  NullUsersLoader=async()=>{

  // const UsersPromise= await apiRequest(`/clients/users`)
  const UsersPromise= await encryptedapiRequest(`/clients/users`)



  // console.log("displayclientspage loader loaded")
  return ({
    UsersResponse: UsersPromise.data||[],  
  })  

};


export const  getGatewayPayments=async(userId)=>{

  // console.log("getGatewayPayments called with userId:", userId);
  const GatewayPromise= await apiRequest(`/gateway/getpayments?userId=${userId}`)

  // console.log("displayclientspage loader loaded")
  return ({
    GatewayResponse: GatewayPromise.data||[],  
  })  

};



